import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var OutputAction;
(function (OutputAction) {
    let Type;
    (function (Type) {
        Type[Type["OFF"] = 0] = "OFF";
        Type[Type["ON"] = 1] = "ON";
        Type[Type["ON_FOR_DURATION"] = 2] = "ON_FOR_DURATION";
        Type[Type["SET_ANALOG_VALUE"] = 3] = "SET_ANALOG_VALUE";
        //we don't know right name
        Type[Type["CHINA_RELAY_ACTION"] = 42] = "CHINA_RELAY_ACTION";
    })(Type = OutputAction.Type || (OutputAction.Type = {}));
    function isOnForDuration(oa) {
        return oa.action.type === Type.ON_FOR_DURATION;
    }
    OutputAction.isOnForDuration = isOnForDuration;
    OutputAction.get = createAccessors(arrayGetSet('output_actions'), {
        name: 'Действие с выходом',
        physical_output: -1,
        action: { type: Type.OFF, duration: 0.1 },
        turn_on_delay: 0,
        blink_pulses_len: 0,
        lower_priority_actions_output_list: [],
        timetable: {
            checked: false,
            weekday_register: 0,
            time: 0,
        },
        blink_pulses_period: 0,
        analog_value: 0,
    });
})(OutputAction || (OutputAction = {}));
